"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _emotion = require("emotion");

var _react = _interopRequireDefault(require("react"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _omitBy = _interopRequireDefault(require("lodash/omitBy"));

var _pickBy = _interopRequireDefault(require("lodash/pickBy"));

var _some = _interopRequireDefault(require("lodash/some"));

var _reactIntl = require("react-intl");

var _Spinner = _interopRequireDefault(require("@cimpress/react-components/lib/shapes/Spinner"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _reactComponents = require("@cimpress/react-components");

var _services = require("./services");

var _services2 = require("../SkuSelector/services");

var _SelectedSkuBin = _interopRequireDefault(require("../SkuSelector/SelectedSkuBin/SelectedSkuBin"));

var _ListPriceInitiatorWizardModal = require("./ListPriceInitiatorWizardModal");

var _shapes = _interopRequireDefault(require("./shapes"));

var _listPriceInitiatorMessages = require("./listPriceInitiatorMessages");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  vertical-align: sub;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  vertical-align: text-bottom;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  min-height: 150px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  & > .selected-sku-bin__content {\n    flex-basis: 150px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 5px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var displayStyle = (0, _emotion.css)(_templateObject());
var duplicateSkuBinStyle = (0, _emotion.css)(_templateObject2());
var triangleStyle = (0, _emotion.css)(_templateObject3());
var duplicateTextStyle = (0, _emotion.css)(_templateObject4());
var fulfillers = 'fulfillers';

var ListPriceInitiatorConfirmStep =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ListPriceInitiatorConfirmStep, _React$Component);

  function ListPriceInitiatorConfirmStep(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ListPriceInitiatorConfirmStep);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ListPriceInitiatorConfirmStep).call(this, props));
    (0, _reactAutobind.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  (0, _createClass2.default)(ListPriceInitiatorConfirmStep, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var _this$props, contractSkuDetails, duplicateSkuDetails;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, contractSkuDetails = _this$props.contractSkuDetails, duplicateSkuDetails = _this$props.duplicateSkuDetails;

                if (!contractSkuDetails && !duplicateSkuDetails) {
                  this.getSkuDetails();
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "getSkuDetails",
    value: function () {
      var _getSkuDetails = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2() {
        var _this$props2, handleError, merchantName, productFulfiller, setContractSkuDetails, setDuplicateSkuDetails, setSkuDetailsStatus, formatMessage;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = this.props, handleError = _this$props2.handleError, merchantName = _this$props2.merchantName, productFulfiller = _this$props2.productFulfiller, setContractSkuDetails = _this$props2.setContractSkuDetails, setDuplicateSkuDetails = _this$props2.setDuplicateSkuDetails, setSkuDetailsStatus = _this$props2.setSkuDetailsStatus, formatMessage = _this$props2.intl.formatMessage;
                setSkuDetailsStatus(_ListPriceInitiatorWizardModal.LOADING);
                this.loadSkuDetails().catch(function () {
                  setSkuDetailsStatus(_ListPriceInitiatorWizardModal.UNAVAILABLE);
                  handleError(formatMessage(_listPriceInitiatorMessages.listPriceConfirmStep.errorLoadingSkusMessage));
                }).then(function (skuDetails) {
                  if (Object.keys(skuDetails.contractSkuDetails).length === 0) {
                    setSkuDetailsStatus(_ListPriceInitiatorWizardModal.UNAVAILABLE);
                    handleError(formatMessage(_listPriceInitiatorMessages.listPriceConfirmStep.allSkusHaveContractsErrorMessage, {
                      merchantName: merchantName,
                      fulfillerName: productFulfiller.name
                    }));
                  } else {
                    setContractSkuDetails(skuDetails.contractSkuDetails);
                    setDuplicateSkuDetails(skuDetails.duplicateSkuDetails);
                    setSkuDetailsStatus(_ListPriceInitiatorWizardModal.AVAILABLE);
                  }
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSkuDetails() {
        return _getSkuDetails.apply(this, arguments);
      }

      return getSkuDetails;
    }()
  }, {
    key: "getDuplicateSkus",
    value: function () {
      var _getDuplicateSkus = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3() {
        var _this$props3, isProduction, merchantId, onGetAccessToken, productFulfiller, skus, seller, response;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props3 = this.props, isProduction = _this$props3.isProduction, merchantId = _this$props3.merchantId, onGetAccessToken = _this$props3.onGetAccessToken, productFulfiller = _this$props3.productFulfiller, skus = _this$props3.skus;
                seller = {
                  type: fulfillers,
                  id: productFulfiller.id
                };
                _context3.next = 4;
                return (0, _services.searchBySku)(skus, seller, onGetAccessToken, isProduction);

              case 4:
                response = _context3.sent;
                return _context3.abrupt("return", skus.filter(function (sku) {
                  return (0, _some.default)(response.activeTerms, function (term) {
                    return term.isEffective && term.activeTerm.sku === sku && term.activeTerm.type === 'list' && term.activeTerm.buyer.id === merchantId;
                  });
                }));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getDuplicateSkus() {
        return _getDuplicateSkus.apply(this, arguments);
      }

      return getDuplicateSkus;
    }()
  }, {
    key: "loadSkuDetails",
    value: function () {
      var _loadSkuDetails = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4() {
        var duplicateSkusTask, allSkuDetailsTask, duplicateSkus, allSkuDetails, duplicateSkuDetails, contractSkuDetails;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getDuplicateSkus();

              case 2:
                duplicateSkusTask = _context4.sent;
                _context4.next = 5;
                return this.loadAllSkuDetails();

              case 5:
                allSkuDetailsTask = _context4.sent;
                _context4.next = 8;
                return duplicateSkusTask;

              case 8:
                duplicateSkus = _context4.sent;
                _context4.next = 11;
                return allSkuDetailsTask;

              case 11:
                allSkuDetails = _context4.sent; // Break up into skus on contract and skus to be excluded (duplicates)

                duplicateSkuDetails = (0, _pickBy.default)(allSkuDetails, function (skuDetail) {
                  return duplicateSkus.includes(skuDetail.sku);
                });
                contractSkuDetails = (0, _omitBy.default)(allSkuDetails, function (skuDetail) {
                  return Object.keys(duplicateSkuDetails).includes(skuDetail.sku);
                });
                return _context4.abrupt("return", {
                  contractSkuDetails: contractSkuDetails,
                  duplicateSkuDetails: duplicateSkuDetails
                });

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function loadSkuDetails() {
        return _loadSkuDetails.apply(this, arguments);
      }

      return loadSkuDetails;
    }()
  }, {
    key: "loadAllSkuDetails",
    value: function () {
      var _loadAllSkuDetails = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5() {
        var _this$props4, onGetAccessToken, skus, skuResponse;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$props4 = this.props, onGetAccessToken = _this$props4.onGetAccessToken, skus = _this$props4.skus;
                _context5.next = 3;
                return (0, _services2.getSkuInfoMapWithSkuList)(skus, onGetAccessToken, false, true);

              case 3:
                skuResponse = _context5.sent;
                return _context5.abrupt("return", skuResponse.skuMap);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function loadAllSkuDetails() {
        return _loadAllSkuDetails.apply(this, arguments);
      }

      return loadAllSkuDetails;
    }()
  }, {
    key: "renderSkuDetails",
    value: function renderSkuDetails() {
      var status = this.props.status;

      if (status === _ListPriceInitiatorWizardModal.LOADING) {
        return _react.default.createElement(_Spinner.default, null);
      }

      if (status === _ListPriceInitiatorWizardModal.UNAVAILABLE) {
        return null;
      }

      var duplicateSkuDisplay = this.renderDuplicateSkuDisplay();
      var contractSkuDisplay = this.renderContractSkuDisplay();
      return _react.default.createElement(_react.default.Fragment, null, duplicateSkuDisplay, contractSkuDisplay);
    }
  }, {
    key: "renderDuplicateSkuDisplay",
    value: function renderDuplicateSkuDisplay() {
      var _this$props5 = this.props,
          duplicateSkuDetails = _this$props5.duplicateSkuDetails,
          merchantName = _this$props5.merchantName,
          productFulfiller = _this$props5.productFulfiller,
          _this$props5$intl = _this$props5.intl,
          formatMessage = _this$props5$intl.formatMessage,
          locale = _this$props5$intl.locale;
      var duplicateSkuList = Object.keys(duplicateSkuDetails);

      if (duplicateSkuList.length === 0) {
        return null;
      }

      var showFilter = duplicateSkuList.length > 10;
      return _react.default.createElement("div", null, _react.default.createElement(_reactComponents.Tooltip, {
        direction: "right",
        contents: formatMessage(_listPriceInitiatorMessages.listPriceConfirmStep.skusHaveContractsWarning, {
          merchantName: merchantName,
          fulfillerName: productFulfiller.name
        })
      }, _react.default.createElement("span", {
        className: triangleStyle
      }, _react.default.createElement(_reactComponents.Icon, {
        color: colors.warning.base,
        name: "report-problem-triangle-f"
      })), _react.default.createElement("span", {
        className: duplicateTextStyle
      }, _react.default.createElement("b", null, formatMessage(_listPriceInitiatorMessages.listPriceConfirmStep.excludedSkus, {
        count: duplicateSkuList.length
      })))), _react.default.createElement(_SelectedSkuBin.default, {
        className: duplicateSkuBinStyle,
        locale: locale,
        disabled: false,
        clickable: false,
        skus: duplicateSkuDetails,
        showCsvDownload: false,
        showFilter: showFilter
      }));
    }
  }, {
    key: "renderContractSkuDisplay",
    value: function renderContractSkuDisplay() {
      var _this$props6 = this.props,
          contractSkuDetails = _this$props6.contractSkuDetails,
          _this$props6$intl = _this$props6.intl,
          formatMessage = _this$props6$intl.formatMessage,
          locale = _this$props6$intl.locale;
      var skuList = Object.keys(contractSkuDetails);

      if (skuList.length === 0) {
        return null;
      }

      var showFilter = skuList.length > 10;
      return _react.default.createElement("div", null, _react.default.createElement("div", {
        className: displayStyle
      }, _react.default.createElement("b", null, formatMessage(_listPriceInitiatorMessages.listPriceConfirmStep.includedSkus, {
        count: skuList.length
      }))), _react.default.createElement(_SelectedSkuBin.default, {
        className: duplicateSkuBinStyle,
        locale: locale,
        disabled: false,
        clickable: false,
        skus: contractSkuDetails,
        showCsvDownload: false,
        showFilter: showFilter
      }));
    }
  }, {
    key: "renderModifier",
    value: function renderModifier() {
      var _this$props7 = this.props,
          modifiers = _this$props7.modifiers,
          formatMessage = _this$props7.intl.formatMessage;

      if (!modifiers || !modifiers.markupPercent && !modifiers.discountPercent) {
        return null;
      }

      return modifiers.discountPercent ? _react.default.createElement("div", {
        className: displayStyle
      }, _react.default.createElement("b", null, formatMessage(_listPriceInitiatorMessages.listPriceConfirmStep.discount)), ": ", modifiers.discountPercent, "%") : _react.default.createElement("div", {
        className: displayStyle
      }, _react.default.createElement("b", null, formatMessage(_listPriceInitiatorMessages.listPriceConfirmStep.markup)), ": ", modifiers.markupPercent, "%");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          contractName = _this$props8.contractName,
          endDate = _this$props8.endDate,
          merchantName = _this$props8.merchantName,
          productFulfiller = _this$props8.productFulfiller,
          startDate = _this$props8.startDate,
          formatMessage = _this$props8.intl.formatMessage;
      var selectedStartDateDisplay = startDate.format('YYYY-MM-DD');
      var selectedEndDateDisplay = !endDate || endDate.year() === 9999 ? formatMessage(_listPriceInitiatorMessages.listPriceConfirmStep.noEndDate) : endDate.format('YYYY-MM-DD');
      var modifierDiv = this.renderModifier();

      var contractDetails = _react.default.createElement("div", null, _react.default.createElement("div", {
        className: displayStyle
      }, _react.default.createElement("b", null, formatMessage(_listPriceInitiatorMessages.listPriceConfirmStep.name)), ": ", contractName), modifierDiv, _react.default.createElement("div", {
        className: displayStyle
      }, _react.default.createElement("b", null, formatMessage(_listPriceInitiatorMessages.listPriceConfirmStep.buyer)), ": ", merchantName), _react.default.createElement("div", {
        className: displayStyle
      }, _react.default.createElement("b", null, formatMessage(_listPriceInitiatorMessages.listPriceConfirmStep.seller)), ": ", productFulfiller.name), _react.default.createElement("div", {
        className: displayStyle
      }, _react.default.createElement("b", null, formatMessage(_listPriceInitiatorMessages.listPriceConfirmStep.startDate)), ": ", selectedStartDateDisplay), _react.default.createElement("div", {
        className: displayStyle
      }, _react.default.createElement("b", null, formatMessage(_listPriceInitiatorMessages.listPriceConfirmStep.endDate)), ": ", selectedEndDateDisplay));

      var skuDetails = this.renderSkuDetails();
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("h5", null, formatMessage(_listPriceInitiatorMessages.listPriceConfirmStep.confirmContractDetails)), contractDetails, skuDetails);
    }
  }]);
  return ListPriceInitiatorConfirmStep;
}(_react.default.Component);

ListPriceInitiatorConfirmStep.defaultProps = {
  isProduction: false
};

var _default = (0, _reactIntl.injectIntl)(ListPriceInitiatorConfirmStep);

exports.default = _default;